import { defineComponent, SVGAttributes } from "vue";

  export const SvgTimer = defineComponent<SVGAttributes>({
    setup() {
      return () => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m13.292 3.8 1.2 1.2 1.5-1.5-3.4-3.5-1.5 1.5 1.2 1.2-.8864.8864.0118.0118a7.01372 7.01372 0 1 0 1.0207 1.0242l.0157.0158zm-6.292 10.6167a5.3906 5.3906 0 1 1 5.3906-5.3906 5.3906 5.3906 0 0 1 -5.3906 5.3906zm-.883-4.6605a1.2675 1.2675 0 0 0 1.7925.0075l.0075-.0075a24.19146 24.19146 0 0 0 1.8-3.6 30.21066 30.21066 0 0 0 -3.6 1.8 1.2675 1.2675 0 0 0 -.0075 1.7925z"/></svg>;
    },
  });